module.exports = __webpack_public_path__ + "static/media/background.653330d6.png";